import loadable from "@loadable/component";
import { inject } from "mobx-react";
import React from "react";
import type { Store } from "../../../../client/stores";
import type { OnAirShowFragment } from "../../generated/webapi.g";
import { daysOfWeek, DaysOfWeekInterface, getLiveUrl } from "../../lib/onair";
import "./OnAirSchedule.style.scss";
import { OnAirScheduleItems } from "./OnAirScheduleItems.component";

const OnAirScheduleCurrent = loadable(() => import("./OnAirScheduleCurrent.component"));

interface OnAirScheduleDayProps {
    timezone: string;
    currentShow: OnAirShowFragment | null | undefined;
    schedule: OnAirShowFragment[];
    selectedDay: DaysOfWeekInterface;
    store?: Store;
}

export const OnAirScheduleDay = inject("store")((props: OnAirScheduleDayProps) => {
    if (!props.store) {
        return null;
    }
    const { env, site } = props.store;
    const liveUrl = site ? getLiveUrl(props.store) : "";
    const hostname = env?.IMAGE_HOST || "";
    const now = env?.TIME_OVERRIDE ? parseFloat(env.TIME_OVERRIDE) : Date.now();
    let dayOfWeekIndex = new Date(now).getDay() - 1;
    if (dayOfWeekIndex === -1) {
        dayOfWeekIndex = 6;
    }
    const currentDayFull = daysOfWeek[dayOfWeekIndex].full;
    return (
        <div className="component-onair-schedule">
            {props.currentShow && currentDayFull === props.selectedDay.full ? (
                <OnAirScheduleCurrent
                    liveUrl={liveUrl}
                    currentShow={props.currentShow}
                    timezone={props.timezone}
                    stationLogo={site.sections?.design?.station_logo?.id}
                    env={env!}
                />
            ) : null}
            <ul className="onair-schedule-day">
                <OnAirScheduleItems
                    timezone={props.timezone}
                    items={props.schedule}
                    hostname={hostname}
                    stationLogo={site.sections.design?.station_logo?.id}
                    env={env}
                />
            </ul>
        </div>
    );
});

export default OnAirScheduleDay;
